import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataImportExportRoutingModule } from './data-import-export-routing.module';
import {DataImportExportComponent} from './data-import-export.component';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {DataExportModule} from './data-export/data-export.module';
import { DataImportModule } from './data-import/data-import.module';

@NgModule({
  declarations: [DataImportExportComponent],
  imports: [
    CommonModule,
    DataImportExportRoutingModule,
    NgbModule,
    DataExportModule,
    DataImportModule
  ],
  exports:[DataImportExportComponent]
})
export class DataImportExportModule { }
